export const isBetween = (int, min, max) => (int - min) * (int - max) <= 0;
export const extractItem = (arr) =>
  arr.splice(Math.floor(Math.random() * arr.length), 1)[0];